import * as React from 'react';
import { Button, UIHeading2, UIText1, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as styles from './DobroFormSuccess.css';
import successSvgUrl from './success.svg';

interface IDobroFormSuccessProps {
  buttonOnClick: () => void;
}

export const DobroFormSuccess: React.FC<IDobroFormSuccessProps> = props => {
  const { buttonOnClick } = props;
  const deviceType = useDeviceType();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const img = (
    <div className={styles.image}>
      <img src={successSvgUrl} />
    </div>
  );

  return (
    <div
      className={clsx(styles.page, {
        [styles.desktop]: deviceType === 'desktop',
      })}
    >
      {deviceType !== 'desktop' && img}
      <div className={styles.heading}>
        <UIHeading2>Заявка отправлена</UIHeading2>
      </div>
      <div className={styles.text}>
        <UIText1>
          Спасибо за&nbsp;заявку на&nbsp;помощь жильем! Сейчас она проходит проверку, это может занять
          до&nbsp;3&nbsp;дней.
        </UIText1>
      </div>

      {deviceType === 'desktop' && img}
      <div className={styles.button}>
        <Button fullWidth={deviceType !== 'desktop'} onClick={buttonOnClick}>
          Буду ждать
        </Button>
      </div>
    </div>
  );
};
